// extracted by mini-css-extract-plugin
export default {"l_function_icon_main":"FunctionIcon_l_function_icon_main__-DHSm","l_function_icon__img":"FunctionIcon_l_function_icon__img__TfVSg"};